<div
  class="flex flex-col justify-between min-h-screen bg-cover bg-center w-full"
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="bg-[#272c36] bg-opacity-60 h-[100vh]">
    <!-- Cookie Consent -->
    <div class="fixed top-0 w-full z-50 h-[25%]">
      <app-cookie-consent
        (popupClosed)="handlePopupClosed()"
      ></app-cookie-consent>
      <!-- Auth Header -->
      <app-auth-header></app-auth-header>
    </div>

    <div
      class="!pb-[8.375rem]"
      [ngClass]="!cookiesClosed ? 'pt-[9.375rem]' : 'pt-[5.375rem]'"
    >
      <!-- Login Component -->
      <app-login></app-login>
    </div>

    <!-- Footer -->
    <div class="w-full fixed bottom-0 w-full z-50">
      <app-footer></app-footer>
    </div>

    <!-- Chat Icon and Popup -->
    <div
      class="fixed bottom-28 z-50 right-16 h-[3.5rem] w-[3.5rem] bg-[#EAEDEF] flex justify-center items-center rounded-[16px] cursor-pointer"
      (click)="setIsOpen()"
    >
      <img
        *ngIf="!isOpen"
        src="assets/icons/chat_icon.svg"
        alt="Chat Icon"
        class="w-[2rem] h-[2rem]"
      />
      <img
        *ngIf="isOpen"
        src="assets/icons/cross_icon.svg"
        alt="Chat Icon"
        class="w-[1.5rem] h-[1.5rem]"
      />
    </div>

    <div
      *ngIf="isOpen"
      class="fixed bottom-[10.5rem] right-[7rem] w-[28vw] !max-h-[65vh] rounded-[8px] border border-[#E76B3F] bg-[#EFF8FF] z-50 shadow-lg"
    >
      <app-chat></app-chat>
    </div>
  </div>
</div>
